import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "../../../components/misc/Headings.js";
import { ReactComponent as PlusIcon } from "feather-icons/dist/icons/plus.svg";
import { ReactComponent as MinusIcon } from "feather-icons/dist/icons/minus.svg";
import { useTranslation } from "react-i18next";
const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto `;

const TwoColumn = tw.div`flex flex-col items-center`;
const Column = tw.div`w-full`;

const FAQContent = styled.div`
    ${tw`lg:ml-6 w-full`}
`;

const Subheading = tw(SubheadingBase)`mb-4 text-center lg:text-left`;
const HeadingContainer = tw.div`flex flex-col items-center justify-center w-full text-center`;

const Heading = styled(SectionHeading)`
    ${tw`text-center text-3xl lg:text-4xl`} /* Удалена привязка к lg:text-left */
    span {
        ${tw`text-green-1002`}
    }
`;


const FAQSContainer = tw.dl`mt-12 w-full`;
const FAQ = styled.div`
    ${tw`cursor-pointer select-none border lg:border-0 px-8 py-4 lg:p-0 rounded-lg lg:rounded-none mt-4`}
    @media (max-width: 768px) {
    ${tw`px-4 py-2`}
}
`;

const Question = tw.dt`flex justify-between items-center`;
const QuestionText = styled.span`
    ${tw`text-lg lg:text-xl font-semibold`}
    @media (max-width: 768px) {
        ${tw`text-base`} /* Reduce text size for mobile */
    }
`;
const QuestionToggleIcon = styled.span`
    ${tw`ml-2 text-gray-100 p-2 rounded-full group-hover:text-gray-200 transition duration-300`}
    background-color: #0ABD19;
    width: 32px; /* Ensure width and height are equal */
    height: 32px; /* Ensure width and height are equal */
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        ${tw`w-6 h-6`} /* Increased size of the plus/minus icons */
    }
`;
const Answer = motion(tw.dd`pointer-events-none mt-4 text-base xl:text-lg my-2 lg:my-4 text-gray-700  leading-relaxed `);

export default ({
                    subheading = "",
                    heading = null,
                    faqs = null
                }) => {
    const { t } = useTranslation();

    const defaultFaqs  = [
        { question: t("faqs.q1"), answer: t("faqs.a1") },
        { question: t("faqs.q2"), answer: t("faqs.a2") },
        { question: t("faqs.q3"), answer: t("faqs.a3") },
        { question: t("faqs.q4"), answer: t("faqs.a4") },
        { question: t("faqs.q5"), answer: t("faqs.a5") },
        { question: t("faqs.q6"), answer: t("faqs.a6") },
    ];


    if (!faqs || faqs.length === 0) faqs = defaultFaqs;

    const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

    const toggleQuestion = questionIndex => {
        if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
        else setActiveQuestionIndex(questionIndex);
    };

    return (
        <Container>
            <Content>
                <TwoColumn>
                    <Column>
                        <FAQContent>
                            {subheading && <Subheading>{subheading}</Subheading>}
                            <HeadingContainer>
                                <Heading>
                                    <span>{t("faqs.headingEmph")}</span> {t("faqs.headingRest")}
                                </Heading>
                            </HeadingContainer>
                            <FAQSContainer>
                                {faqs.map((faq, index) => (
                                    <FAQ
                                        key={index}
                                        onClick={() => {
                                            toggleQuestion(index);
                                        }}
                                        className="group"
                                    >
                                        <Question>
                                            <QuestionText>{faq.question}</QuestionText>
                                            <QuestionToggleIcon>
                                                {activeQuestionIndex === index ? <MinusIcon /> : <PlusIcon />}
                                            </QuestionToggleIcon>
                                        </Question>
                                        <Answer
                                            variants={{
                                                open: { opacity: 1, height: "auto", marginTop: "16px" },
                                                collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                                            }}
                                            initial="collapsed"
                                            animate={activeQuestionIndex === index ? "open" : "collapsed"}
                                            transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                                        >
                                            {faq.answer}
                                        </Answer>
                                    </FAQ>
                                ))}
                            </FAQSContainer>
                        </FAQContent>
                    </Column>
                </TwoColumn>
            </Content>
        </Container>
    );
};
